import React, { useRef, useState } from 'react';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-h5-audio-player/lib/styles.css';
import "react-image-crop/dist/ReactCrop.css";
import AddPostContent, { AddPostContentHandle } from './add-post-content';
import { ChevronLeft, FileText, X } from 'lucide-react';
import BottomSheet from '../../bottom-sheet/bottom-sheet';
import { useMediaEditor } from '../../../hooks/useMediaEditor';
import MediaEditor from '../../media-editor';
import { t } from '../../../global-components/src/i18nTranslate';
import { listDrafts } from '../../../hooks/useDraft';

interface FilePreview {
  file: File;
  src: string;
  type?: string;
}

interface AddPostProps {
  id_community?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

const AddPostBottom: React.FC<AddPostProps> = ({ id_community, open, setOpen }) => {
  const [selectedFiles, setSelectedFiles] = useState<FilePreview[]>([]);
  const contentRef = useRef<AddPostContentHandle | null>(null);

  const editor = useMediaEditor();

  // Always read live so the button appears as soon as drafts exist
  const draftCount = listDrafts().length;

  const handleEditImage = (file: File, index: number) => {
    // Fecha o bottom sheet antes de abrir o editor
    setOpen(false);

    editor.open(file, {
      onConfirm: (editedFile: File) => {
        setSelectedFiles(prev => {
          const updated = [...prev];
          updated[index] = {
            file: editedFile,
            src: URL.createObjectURL(editedFile),
            type: 'image',
          };
          return updated;
        });

        // Reabre o bottom sheet após edição
        setOpen(true);
      },
      onCancel: () => {
        // Cancela → volta pro bottom sheet
        setOpen(true);
      },
    });
  };

  return (
    <>
      <div className="col-10">
        <BottomSheet disableDrag snapPoints={[0, 1]} open={open} setOpen={setOpen}>
          {/* <div id="username-suggestions" />
          <div className="modal-content modal-content-likes">
            <div className="modal-header modal-header-add-post" style={{ borderBottom: '0!important' }}>
              <h4 className="modal-title d-flex justify-content-center">
                <span
                  style={{ marginLeft: -7, marginRight: 5, marginTop: 2 }}
                  onClick={() => setOpen(false)}
                  className="d-flex align-items-center svg-icons-color btn-dark"
                >
                  <ChevronLeft opacity={0.6} />
                </span>
                Publicação
              </h4>
            </div>

            <div className="modal-body" style={{ position: 'static' }}>
              <AddPostContent
                setOpen={setOpen}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                onEditImage={handleEditImage}
              />
            </div>
          </div> */}
            <div className="modal-dialog cover-mobile">
              <div id="username-suggestions" />
              <div className="modal-content modal-post">
                <div className="ap-modal-header">
                  <button
                    type="button"
                    className="foc-pc-close"
                    onClick={() => contentRef.current?.requestClose()}
                  >
                    <X size={18} />
                  </button>

                  <h3 className="foc-pc-title" id={`modal-post${id_community ? '-community' : ''}`}>
                    {t('post.title')}
                  </h3>

                  {draftCount > 0 && (
                    <button
                      type="button"
                      className="ap-drafts-btn"
                      onClick={() => contentRef.current?.openDrafts()}
                    >
                      <FileText size={14} /> {draftCount}
                    </button>
                  )}
                </div>

                <div
                  className="modal-body"
                  style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0, minHeight: 150 }}
                >
                   <AddPostContent
                      ref={contentRef}
                      setOpen={setOpen}
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      onEditImage={handleEditImage}
                    />
                </div>
              </div>
            </div>
          
        </BottomSheet>
      </div>

      {editor.isOpen && (
        <MediaEditor {...editor.props} />
      )}
    </>
  );
};

export default AddPostBottom;